import classNames from "classnames";
import { memo, type ReactNode } from "react";
import { Flex } from "../flex";
import * as css from "./settings-rows.module.css";

/** Inset card of rows that only apply when the row above has a certain value. */
export const SettingsChildren = memo(function SettingsChildren({
  visible = true,
  standalone = false,
  children,
}: {
  visible?: boolean;
  /** No parent row above to space it from the card edge. */
  standalone?: boolean;
  children: ReactNode;
}) {
  if (!visible) {
    return null;
  }
  return (
    <Flex
      className={css.children}
      dir="column"
      gap="none"
      pb="xl"
      pt={standalone ? "xl" : "none"}
      px="2xl"
    >
      <Flex
        className={classNames(css.tintedCard, css.rowList, css.rowListStrong)}
        dir="column"
        gap="none"
        w="full"
      >
        {children}
      </Flex>
    </Flex>
  );
});
